export enum EType {
    Bronchoscope = 1,
    Coloscope,
    Cystoscope,
    Duodenoscope,
    Echoendoscope,
    Gastroscope,
    Ureteroscope,
    Scialendoscope,
    Choledoscope,
    Hysteroscope,
    EchoendoBronchique,
    Nasogastroscope,
    Enteroscope,
}